// @flow
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { fetchDataForItemPage } from '../../../redux/modules/itemPage';
import { getIdFromPath } from '../../../utils/urls';
import { getItemFacets } from '../../../redux/modules/itemFacets';
import { isUserLoggedIn } from '../../../redux/modules/user';
import { recordAnalyticsForItemPageView } from '../../../redux/modules/analytics';
import { submitIsSavedSearchCheck } from '../../../redux/modules/saveSearchCheck';

export default ({ match, store }: DataLoaderParams) => {
    const { params } = match;
    const { dispatch, getState } = store;
    const itemId = getIdFromPath(params.itemId);

    if (!itemId) {
        return Promise.all([]);
    }

    return dispatch(fetchDataForItemPage(itemId)).then(() => {
        const state = getState();
        const userLoggedIn = isUserLoggedIn(state);
        const facets = getItemFacets(state, itemId);
        if (userLoggedIn) {
            return dispatch(submitIsSavedSearchCheck(undefined, facets)).then(() => {
                return dispatch(recordAnalyticsForItemPageView(itemId));
            });
        } else {
            return dispatch(recordAnalyticsForItemPageView(itemId));
        }
    });
};
